import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit {
  notifications: any[];
  messages: any[];
  files: any[];
  closeDropdown: EventEmitter<boolean>;
  @Input() layout: string;

  constructor(
    private httpSv: HttpService,
    private router: Router
  ) {
    this.notifications = [];
    this.messages = [];
    this.files = [];
    this.closeDropdown = new EventEmitter<boolean>();
    // this.layout = 'vertical';
    this.layout = 'horizontal';
  }

  ngOnInit() {}

  getData(url: string, dataName: string) {
    this.httpSv.getData(url).subscribe(
      data => {
        this[dataName] = data;
      },
      err => {
        console.log(err);
      }
    );
  }

  onCloseDropdown() {
    this.closeDropdown.emit(true);
  }
  logoutCloseDropDown() {
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    if (localStorage.getItem('data')) {
      localStorage.removeItem('data');
    }
    this.closeDropdown.emit(true);
  }
  goToSettings(event: Event) {
    event.preventDefault();

    this.onCloseDropdown();

    setTimeout(() => {
      this.router.navigate(['settings/setting']);
    });
  }
  // logout from app
  logout(event: Event) {
    event.preventDefault();
    this.logoutCloseDropDown();
    setTimeout(() => {
      this.router.navigate(['']);
    });
  }
}
